import { injectable } from 'inversify';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ContentPayload } from '../../canvas/injection/ContentPayload';
import { ContentProcessor } from '../../canvas/injection/ContentProcessor';
import { resolve } from '../../Container';
import { createNativeVideo, createYouTubeVideo, parseYouTubeVideoId } from './VideoCommands';

const isNativeVideoUrl = (url: string) => {
    url = url.toLowerCase();
    return url.startsWith('http') && url.endsWith('.mp4')
};

@injectable()
export class EmbedFromTextFileProcessor implements ContentProcessor {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;

    public readonly supportedTypes = Object.freeze([
        'text/plain',
    ]);

    public async process(payload: ContentPayload): Promise<boolean | ContentPayload> {
        const { data, metadata } = payload;

        // Check is file or blob or string
        if (!(typeof (data) === 'string' || data instanceof File || data instanceof Blob)) {
            // input must be a File or Blob.
            return false;
        }

        const textData = typeof (data) === 'string' ? data : await data.text();
        if (!textData) return false;

        if (isNativeVideoUrl(textData)) {
            this.dispatch(createNativeVideo, [textData]);
            return true;
        }

        const isYouTubeUrl = !!parseYouTubeVideoId(textData);
        if (isYouTubeUrl) {
            this.dispatch(createYouTubeVideo, [textData]);
            return true;
        }

        return false;
    }
}
